<template>
  <div>
    <div class="number-input">
      <div class="input-button decrease" @click="decrease">&minus;</div><input type="number" v-on:input="updateValue" v-bind:value="value" v-bind:name="model" v-bind:min="min" v-bind:max="max"><div class="input-button increase" @click="increase">&plus;</div>
    </div>
    <label v-bind:for="model">{{label}}</label>
  </div>
</template>

<script>
export default {
  name: 'input-number',
  props: ['model', 'label', 'value', 'min', 'max'],
  data() {
    return {

    }
  },
  methods: {
    updateValue(e) {
      this.$emit('update-value', this.model, e.target.value)
    },
    decrease(e) {
      let newValue = this.value - 1
      if (newValue >= this.min) {
        this.$emit('update-value', this.model, newValue)
      }
      else {
        if (this.model === 'minutes') {
          this.$emit('hit-minute-min')
        }
        else {
          this.$emit('update-value', this.model, this.min)
        }
      }

    },
    increase(e) {
      let newValue = this.value + 1
      if (newValue <= this.max) {
        this.$emit('update-value', this.model, newValue)
      }
      else {
        if (this.model === 'minutes') {
          this.$emit('hit-minute-max')
        }
        else {
          this.$emit('update-value', this.model, this.min)
        }

      }
    }
  }

};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.number-input {
  display: flex;
  height: 60px;
  margin: auto;
  margin-bottom: 20px;
  justify-content: center;
}
label {
  display: block;
  text-align: center;
  color: #498CA5;
  margin-bottom: 20px;
}
input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.input-button {
  background-color: #DCE8ED;
  width: 25%;
  font-size: 30px;
  text-align: center;
  color: #4A869D;
  display: flex;
  flex-direction: column;
  justify-content: center;
  -webkit-touch-callout: none; /* iOS Safari */
  -webkit-user-select: none; /* Safari */
   -khtml-user-select: none; /* Konqueror HTML */
     -moz-user-select: none; /* Firefox */
      -ms-user-select: none; /* Internet Explorer/Edge */
          user-select: none; /* Non-prefixed version, currently
                                supported by Chrome and Opera */
}

.input-button:hover {
  cursor: pointer;
}
input[type="number"] {
  width: 50%;
  font-size: 20px;
  text-align: center;
  padding: 10px;
  border-radius: 0;
  outline: none;
  -webkit-appearance: none;
  -moz-appearance: textfield;
  -ms-appearance: none;
  -o-appearance: none;
  appearance: none;
  border: none;

}

</style>



// WEBPACK FOOTER //
// InputNumber.vue?5c8807d9